import React, {useEffect} from 'react';
import styles from './EledoTabs.module.scss';
import classnames from "classnames";
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export type EledoTabsProps = {
  id: string
  children: React.ReactNode
  tabContentStyle?: React.CSSProperties
}

const EledoTabs = ({ id, children, tabContentStyle = undefined  } : EledoTabsProps) => {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams<{ tabKey?: string }>()

  const tabs = React.Children.toArray(children).map((child: any) => ({
    label: child.props.label as string,
    urlKey: child.props.path,
    child
  }));

  const activeKey = params.tabKey ?? tabs[0].urlKey;
  const activeIndex = tabs.findIndex(t => t.urlKey === activeKey);
  const activeTab = tabs[activeIndex]

  useEffect(() => {
    if(activeIndex === undefined)
      onClickTabItem(0)
  }, [id, activeIndex]);

  const onClickTabItem = (tabIndex: number) => {
    const tab = tabs[tabIndex]
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const lastSeg = pathSegments[pathSegments.length - 1];

    const cleaned = tabs.some(t => t.urlKey === lastSeg)
      ? pathSegments.slice(0, -1)
      : pathSegments;

    const basePath = "/" + cleaned.join("/");

    navigate(`${basePath}/${tab.urlKey}`);
  }

  if(!Array.isArray(children)){
    children = [children];
  }

  return (
    <div className= {classnames(styles.EledoTabs, "stretch-vertically", "vertical-scroll")}>
      <ol className={styles.tabList}>
        {tabs.map((tab, index) => {
          return (
            <li key={tab.urlKey} className={styles.tabListItem}>
              <a className={classnames(activeIndex === index ? styles.activeTab : '', styles.tabLink)}
                onClick={(e) => {e.preventDefault(); onClickTabItem(index)}}
                href="/">
                  {tab.label}
              </a>
            </li>
          );
        })}
      </ol>
      <div className={classnames(styles.tabContent, "my-section", "stretch-vertically", "vertical-scroll")} style={tabContentStyle}>
        {activeTab.child}
      </div>
    </div>
  )

};

export type EledoTabProps = {
  label: string
  path: string
  children?: React.ReactNode
}

export const EledoTab: React.FC<EledoTabProps> = ({ children }) => {
  return <>{children}</>
}

export default EledoTabs;
